'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { analytics } from '@/services/analytics';

export default function AnalyticsTracker() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        // Setup analytics on mount
        analytics.setupLazyLoad();
    }, []);

    useEffect(() => {
        // Track page views on route change
        const url = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
        analytics.trackPageView(url);
    }, [pathname, searchParams]);

    return null;
}
